module.exports = __webpack_public_path__ + "static/img/2_1_2_2.709d308e.jpg";